import * as React from 'react';
import { ForgeRunnerModule } from 'view/forge-ui/forge-runner';
import { ForgeRunnerContainer } from 'view/forge-ui/forge-runner/styled';
import { PORTAL_FOOTER_MODULE } from '@atlassian/help-center-common-component/forge-ui/constants';
import type { ForgePagePanelCommonProps } from '@atlassian/help-center-common-component/forge-ui/types';

const ForgeFooterModule: React.FC<ForgePagePanelCommonProps> = ({
    page,
    portalId,
    projectId,
    requestKey,
    requestTypeId,
}) => (
    <ForgeRunnerContainer>
        <ForgeRunnerModule
            type={PORTAL_FOOTER_MODULE}
            page={page}
            projectId={projectId}
            portalId={portalId}
            requestKey={requestKey}
            requestTypeId={requestTypeId}
        />
    </ForgeRunnerContainer>
);

export default ForgeFooterModule;
